<template>
  <div class="navList">
    <div class="nav swiper-container">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="(item, index) in slideList"
          :key="index"
        >
          <ul>
            <li
              v-for="(childrenItem, childrenIdx) in item"
              :key="childrenIdx"
              @click="goJxClass(childrenItem.classTypeId)"
            >
              <img :src="childrenItem.icon" alt="" />
              <!-- <img src="../../assets/imgs/icon.png" alt=""> -->
              <p>{{ childrenItem.name }}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="nav-pagination"></div>
  </div>
</template>

<script>
import Swiper from "swiper";
export default {
  // name: '首页轮播',
  data() {
    return {
      slideList: [],
    };
  },
  created() {
    var that = this;
    that.getChoiceByPid();
  },
  mounted() {},
  methods: {
    mySwiper() {
      new Swiper(".nav", {
        pagination: {
          el: ".nav-pagination",
        },
      });
    },
    getChoiceByPid() {
      var that = this;
      var data = {
        classTypeId: localStorage.getItem("classTypeId"),
      };
      that.allApi.getChoiceByPid(data).then(function (resource) {
        for (
          var i = 0, len = resource.data.data.list.length / 10;
          i < len;
          i++
        ) {
          that.slideList.push(
            resource.data.data.list.slice(i * 10, (i + 1) * 10)
          );
        }
        that.$nextTick(() => {
          that.mySwiper();
        });
      });
    },
    goJxClass(id) {
      var that = this;
      that.$router.push({
        path: "/classify",
        query: {
          id: id,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
@function rem($args) {
  $uiWidth: 75px;
  @return $args/$uiWidth * 1rem;
}
.navList {
  margin-bottom: rem(42px);
  .nav {
    width: rem(670px);
    margin: 0 auto rem(26px);

    .swiper-slide {
      width: rem(670px);
      // height: rem(251px);
      > ul {
        display: flex;
        // justify-content: space-around;
        flex-wrap: wrap;
        > li {
          width: 20%;
          text-align: center;
          margin-bottom: rem(14px);
          > img {
            display: block;
            width: rem(86px);
            height: rem(86px);
            margin: 0 auto rem(4px);
          }
          > p {
            font-size: rem(24px);
            color: #999;
            line-height: rem(34px);
          }
        }
      }
    }
  }
  > .nav-pagination {
    text-align: center;
  }
}
</style>
<style>
.nav-pagination > .swiper-pagination-bullet {
  margin: 0 4px;
}
</style>
  